"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleSearchQueryField = void 0;
var _baseSearchQueryField = require("./base-search-query-field");
class SimpleSearchQueryField extends _baseSearchQueryField.BaseSearchQueryField {
  get urlSlugs() {
    return [this.urlSlug];
  }
  toUrlParameters() {
    if (this.isDefault()) {
      return [];
    }
    var paramValue = this.getUrlParameterValue();
    return paramValue == null ? [] : [{
      [this.urlSlug]: paramValue
    }];
  }
}
exports.SimpleSearchQueryField = SimpleSearchQueryField;